// extracted by mini-css-extract-plugin
export default {"root":"_1gghJ","thumb":"_2IdcC","selected":"_1tXRT"};